import type { InputHTMLAttributes, ReactNode } from 'react';
import { FormMessage } from './FormMessage';
import { useFieldA11y } from './fieldA11y';

interface SwitchFieldProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, 'aria-invalid' | 'type'> {
  label: ReactNode;
  helperText?: string;
  error?: string;
  containerClassName?: string;
}

export const SwitchField = ({
  id,
  label,
  helperText,
  error,
  className,
  containerClassName,
  ...inputProps
}: SwitchFieldProps) => {
  const { fieldId, helperId, errorId, describedByIds } = useFieldA11y({
    id,
    describedBy: inputProps['aria-describedby'],
    helperText,
    error,
  });

  return (
    <div
      className={[
        'form-choice',
        'form-switch',
        error ? 'form-choice--invalid' : '',
        containerClassName,
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <label className="form-switch__control" htmlFor={fieldId}>
        <span>{label}</span>
        <input
          id={fieldId}
          type="checkbox"
          role="switch"
          aria-describedby={describedByIds}
          {...inputProps}
        />
        <span className="form-switch__track" aria-hidden="true" />
      </label>
      <FormMessage id={helperId}>{helperText}</FormMessage>
      <FormMessage id={errorId} tone="error">
        {error}
      </FormMessage>
    </div>
  );
};
